"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artistTheme = void 0;
var artist_theme_1 = require("./artist.theme");
Object.defineProperty(exports, "artistTheme", { enumerable: true, get: function () { return artist_theme_1.theme; } });
